import * as consultants from './consultants';
import * as slots from './slots';
import * as create from './create';
import * as bookings from './bookings';
import * as cancel from './cancel';

export default {
  ...consultants,
  ...slots,
  ...create,
  ...bookings,
  ...cancel,
};
